export default {
    urlOptsInit: { limit: 10 },
    postBodyInit: []
};
